var exports = {
  "kL": "xfd349460--2e9e0a--container",
  "Sl": "xfd349460--2e9e0a--image",
  "Qq": "xfd349460--2e9e0a--text",
};

module.exports = exports;
